import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';

const TextInput = ({ name, type, value, placeholder, onChange, children, ...props }) => {
  return (
    <Fragment>
      <input
        {...props}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder} />
      {children}
    </Fragment>
  );
}

TextInput.defaultProps = {
  type: "text"
};

TextInput.propTypes = {
  type: PropTypes.oneOf(["text", "number", "email", "tel"]).isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  placeholder: PropTypes.string
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/form/controls/TextInput.js